import { createUploadBridge } from './uploadBridge'

/** Мост «холст → панель» для видео-блока (см. `createUploadBridge`). */
export const videoUploadBridge = createUploadBridge()

export const requestVideoUpload = videoUploadBridge.request
export const onVideoUploadRequest = videoUploadBridge.onRequest
export const setVideoUploadProgress = videoUploadBridge.setProgress
export const subscribeVideoUploadProgress = videoUploadBridge.subscribeProgress
export const getVideoUploadProgress = videoUploadBridge.getProgress
